<template>
  <div>
    <el-upload
      ref="upload"
      :data="fileData"
      :headers="uploadHeads"
      action="/api/file/upload"
      :limit="1"
      :file-list="fileList"
      :auto-upload="false"
      :on-success="uploadSuccess"
      accept="csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      :before-upload="beforeUpload"
    >
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button
        style="margin-left: 10px"
        size="small"
        type="success"
        @click="submitUpload"
        >上传到服务器</el-button
      >
      <div slot="tip" class="el-upload__tip">
        只能上传xls/xlsx文件，且不超过500kb
      </div>
    </el-upload>
  </div>
</template>

<script>
import { getToken } from '../../untils/func';

export default {
  name: 'PictureUpload',
  data() {
    return {
      uploadHeads: { myToken: getToken(), myClientTYpe: 'pc' },
      fileData: { fileType: 'excel', businessFileType: 'basicExcelTemplate' },
      fileList: [],
    };
  },
  created() {},
  methods: {
    clearFilelist() {
      this.fileList = [];
    },
    uploadSuccess(response) {
      if (response.statusCode != 1) {
        this.msgError(response.statusMsg);
        return;
      }
      this.fileList = [];
      this.$emit('onSuccess', response.data);
    },

    submitUpload() {
      this.$refs.upload.submit();
    },

    beforeUpload(file) {
      if (
        file.type !=
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
        file.type != 'application/vnd.ms-excel'
      ) {
        this.msgError('只能上传xls/xlsx文件，且不超过500kb');
        return false;
      }

      if (file.size > 500 * 1024) {
        this.msgError('只能上传xls/xlsx文件，且不超过500kb');
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped></style>
